// Backend API Configuration
export const API_BASE_URL = "https://it-shopping-online-system-backend.onrender.com";

// Image URL helper - constructs full URL for product images
export const imageUrl = (path) => {
    if (!path) return null;
    // If path already starts with http, return as-is
    if (path.startsWith("http://") || path.startsWith("https://")) {
        return path;
    }
    // Otherwise, prepend the base URL
    return `${API_BASE_URL}${path.startsWith("/") ? "" : "/"}${path}`;
};
